'use client';

/** Client-only because MoneyPageTemplate and SectionTitle use styled-components and break in RSC. Follow-up: migrate those lib components to Tailwind/CSS modules so this can be a server component. See apps/bz/docs/PAGES_MIGRATION_APP_ROUTER.md § Client components. */
import { MoneyPageTemplate } from '@benzinga/money';
import { SectionTitle } from '@benzinga/core-ui';
import type { WordpressPage } from '@benzinga/content-manager';

export function PartnerDisclosureContent({ disclosure }: { disclosure: WordpressPage }) {
  return (
    <MoneyPageTemplate
      layoutAboveArticle={
        <div className="explore-offerings-section" id="explore-offerings-section">
          <div className="section-title-container">
            <SectionTitle level={1}>Partner Disclosure</SectionTitle>
          </div>
        </div>
      }
      post={disclosure}
    />
  );
}
